// extracted by css-extract-rspack-plugin
export default {"notificationHeader":"notification-header--RBZHUJdcUyo2ugHx","notificationText":"notification-text--tgsv7APP0QILoMuS","notificationImg":"notification-img--HsjngaOE5VIHq5Fg"};